import * as modes from './modes';
import * as sizes from './sizes';
import { Themes } from './types';

const themes: Themes = {
  modes,
  sizes,
};

export default themes;
